var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#B6B6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1965 14.54V20.26C22.1965 20.8667 22.1665 21.4633 22.1065 22.05C22.0465 22.63 21.9665 23.2467 21.8665 23.9H20.1965C20.0965 23.2467 20.0165 22.63 19.9565 22.05C19.8965 21.4633 19.8665 20.8667 19.8665 20.26V14.54H22.1965ZM19.4865 27.64C19.4865 27.4333 19.5232 27.2367 19.5965 27.05C19.6765 26.8633 19.7832 26.7033 19.9165 26.57C20.0565 26.4367 20.2198 26.33 20.4065 26.25C20.5932 26.17 20.7932 26.13 21.0065 26.13C21.2132 26.13 21.4098 26.17 21.5965 26.25C21.7832 26.33 21.9432 26.4367 22.0765 26.57C22.2098 26.7033 22.3165 26.8633 22.3965 27.05C22.4765 27.2367 22.5165 27.4333 22.5165 27.64C22.5165 27.8533 22.4765 28.0533 22.3965 28.24C22.3165 28.42 22.2098 28.5767 22.0765 28.71C21.9432 28.8433 21.7832 28.9467 21.5965 29.02C21.4098 29.1 21.2132 29.14 21.0065 29.14C20.7932 29.14 20.5932 29.1 20.4065 29.02C20.2198 28.9467 20.0565 28.8433 19.9165 28.71C19.7832 28.5767 19.6765 28.42 19.5965 28.24C19.5232 28.0533 19.4865 27.8533 19.4865 27.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.803c1ccaf033973d1bfb8f3f87b9b36b.svg";
export { ForwardRef as ReactComponent };